import { useFlowExperiment } from './useFlowExperiment/useFlowExperiment'

/**
 * Returns whether the user got bucketed in the 'free-month' variant of the `free_trial_via_locks` experiment
 *
 * @see https://app.optimizely.com/v2/projects/17283172040/experiments/24232480569
 */
export const useIsFreeMonthViaLocksExpVariant = (): boolean => {
  const [expVariant] = useFlowExperiment('free_trials_via_locks')

  return expVariant === 'free-month'
}
